(function($) {
    // Wait for document to get ready.
    $(document).ready(function () {
        const adventCalendarBox = document.querySelector('.advent-calendar')

        if (!adventCalendarBox) {
            return
        }

        const adventCalendarImage = adventCalendarBox.querySelector('.image-wrapper')

        if (!adventCalendarImage) {
            return
        }

        let moving = false
        let offset = [0, 0]

        const onStart = function (e) {
            moving = true
            if (e.target.tagName !== 'A') {
                e.preventDefault()
            }

            if (e.type === 'mousedown') {
                offset = [
                    adventCalendarImage.offsetLeft - e.clientX,
                    adventCalendarImage.offsetTop - e.clientY
                ];
            } else {
                offset = [
                    adventCalendarImage.offsetLeft - e.changedTouches[0].clientX,
                    adventCalendarImage.offsetTop - e.changedTouches[0].clientY
                ];
            }
        }

        const onEnd = function (e) {
            moving = false
        }

        const onMove = function (e) {
            if (!moving) {
                return
            }

            const boxBound = adventCalendarBox.getBoundingClientRect()
            const imgBound = adventCalendarImage.getBoundingClientRect()

            const maxLeft = -(imgBound.width - boxBound.width)
            const maxTop = -(imgBound.height - boxBound.height)

            let mousePosition

            if (e.type === 'mousemove') {
                mousePosition = {
                    x : e.clientX,
                    y : e.clientY
                };
            } else {
                mousePosition = {
                    x : e.changedTouches[0].clientX,
                    y : e.changedTouches[0].clientY
                };
            }

            adventCalendarImage.style.left = Math.max(
                Math.min(
                    mousePosition.x + offset[0],
                    0
                ),
                maxLeft
            ) + 'px';

            adventCalendarImage.style.top  = Math.max(
                Math.min(
                    mousePosition.y + offset[1],
                    0
                ),
                maxTop
            ) + 'px';
        }

        adventCalendarImage.addEventListener('mousedown', onStart)
        adventCalendarImage.addEventListener('touchstart', onStart)

        window.addEventListener('mouseup', onEnd)
        window.addEventListener('touchend', onEnd)

        window.addEventListener('mousemove', onMove)
        window.addEventListener('touchmove', onMove)
    })
})(window.jQuery);
